import { render, staticRenderFns } from "./PromotionSimpleNumericCondition.vue?vue&type=template&id=9ccd1438&"
import script from "./PromotionSimpleNumericCondition.vue?vue&type=script&lang=ts&"
export * from "./PromotionSimpleNumericCondition.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports